import React, { useEffect } from 'react'

const getSafeRedirectUri = (inputRedirectUri) => {
  try {
    const parsed = new URL(inputRedirectUri || '', window.location.origin)
    const isHttp = parsed.protocol === 'http:' || parsed.protocol === 'https:'
    const isSameOrigin = parsed.origin === window.location.origin

    if (!isHttp || !isSameOrigin) {
      return `${window.location.origin}`
    }

    //return parsed.href.endsWith('/') ? parsed.href : `${parsed.href}/`
    return parsed.href 
  } catch (e) {
    return `${window.location.origin}`
  }
}

const OIDCProvider = ({ authCode,client_id,redirect_uri }) => {
    const safeRedirectUri = getSafeRedirectUri(redirect_uri)
    window.localStorage.setItem('redirect_uri', safeRedirectUri)
    var code_verifier = JSON.parse(window.localStorage.getItem('CodeChallenge'))
    var details = {
      grant_type: 'authorization_code',
      redirect_uri: safeRedirectUri,
      client_id: client_id,
      code: authCode,
      code_verifier: code_verifier.code_verifier,
      scope: `openid profile email address phone`,
    }
    var token_url = process.env.REACT_APP_TOKEN_SERVER_URL
    var formBody = Object.keys(details)
      .map(
        (key) => encodeURIComponent(key) + '=' + encodeURIComponent(details[key])
      )
      .join('&')
    fetch(token_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body: formBody,
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json()
        }
        return response.json().then((errData) => {
          console.error('Token endpoint error:', errData)
          return null
        })
      })
      .then((data) => {
        if (data !== undefined && data !== null) {
          var redirect_uri = getSafeRedirectUri(window.localStorage.getItem('redirect_uri')).replace('oidc-login', '') 
          var client_info = '',
            session_state = '',
            state = ''
          var uri =
            `${redirect_uri}msid/login-redirect#id_token=${data.id_token}` +
            `&client_info=${client_info}&session_state=${session_state}` +
            `&state=${state}&code_verifier=${code_verifier.code_verifier}`
          window.localStorage.removeItem('redirect_uri')
          window.localStorage.setItem('id_token', data.id_token)
          window.localStorage.setItem('access_token', data.access_token)
          window.location.href = uri
        }
      })
      .catch((error) => console.error('Token request failed:', error))


  return (
    <div>
      <></>
    </div>
  )
}

export default OIDCProvider
